import exportEvents from 'services/utils/exportEvents';

export default function (name) {
    return {
        mounted() {
            exportEvents.setEventBus(name, this.uniqueId, this);
        },
        beforeDestroy() {
            exportEvents.deregisterEventBus(name, this.uniqueId);
        },
        watch: {
            uniqueId(newVal, oldVal) {
                exportEvents.deregisterEventBus(name, oldVal);
                exportEvents.setEventBus(name, newVal, this);
            }
        }
    };
}
